// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1LH1J","error":"Textarea_error__w-5wh","readonly":"Textarea_readonly__GQnXf","disabled":"Textarea_disabled__YQBNm"};